import { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// import { Slider } from '@contentco/react-scroll-snap-slider';
import Img from '@components/Img';
import Styles from './PressSlider.module.scss';

const PressSlider = forwardRef(({ type, light, pressData }, ref) => {
  return (
    <div className={Styles.container}>
      {/*<Slider ref={ref} disableArrow slideWidth={350}>*/}
      <div ref={ref} className={Styles.newSlider}>
        {pressData.map((item, index) => {
          return (
            <a
              key={index}
              href={item.url}
              className={Styles.item}
              target={`_blank`}
              rel={`noopener noreferrer nofollow`}
              title={item.title}>
              {item.image?.url ? (
                <Img
                  wrapperClassName={Styles.imageContainer}
                  className={classNames(Styles.image)}
                  alt={`Press Banner`}
                  src={item.image?.url}
                />
              ) : (
                <div className={classNames(Styles.imageContainer, Styles.background)} />
              )}

              <div className={Styles.content}>
                <div className={classNames(Styles.title)}>{item.title}</div>
                <div className={Styles.company}>
                  {/*<Img className={Styles.companyImage} alt={item.title} src={item.logo?.url} />*/}
                  <p className={Styles.companyName}>{item.publication}</p>
                </div>
              </div>
            </a>
          );
        })}
      </div>
      {/*</Slider>*/}
    </div>
  );
});

PressSlider.propTypes = {
  type: PropTypes.string,
  light: PropTypes.bool,
};

export default PressSlider;
